import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';

@Component<StepperHeader>({})
export default class StepperHeader extends Vue {
  // #region @PropSyncs

  @PropSync('currentStep')
  protected internalCurrentStep!: number;

  // #region

  // #region @Props

  @Prop({ default: () => [] })
  protected stepHeaders!: StepHeader[];

  // #endregion

  // #region @Refs
  // #endregion

  // #region Props
  // #endregion

  // #region Lifecycle Hooks / Init
  // #endregion

  // #region Handlers

  protected onGoToStep(step: number) {
    if (this.internalCurrentStep < step) {
      return;
    }

    this.internalCurrentStep = step;
  }

  // #endregion

  // #region Helpers
  // #endregion

  // #region Async methods
  // #endregion

  // #region Getters & Setters
  // #endregion

  // #region @Watchers
  // #endregion
}

// #region Enums
// #endregion

// #region Types
// #endregion

// #region Interfaces

export interface StepHeader {
  name?: string;
}

// #endregion
